import React, { useMemo } from 'react';
import axios from 'axios';
import '../../assets/stylesheets/Units/Avatar.scss';

const INCREMENTED_COUNT = 5;

const Avatar = ({ data, isIncrementedFrame }) => {

    const style = useMemo(() => {
      if (!data) return {};
      if (!data.frame) return { backgroundImage: `url(${data.imagePath})` };
      return {
        backgroundImage: `url(${data.imagePath})`,
        backgroundSize: 'initial',
        width: data.frame.w,
        height: data.frame.h,
        backgroundPosition: `-${isIncrementedFrame ? data.frame.x + INCREMENTED_COUNT : data.frame.x}px -${isIncrementedFrame ? data.frame.y + INCREMENTED_COUNT : data.frame.y}px`,
      };
    }, [data]);

    return (
        <React.Fragment>
            { data && data.imagePath &&
                <div className={`avatarImage`} style={style} />
            }
        </React.Fragment>
    )
};
export default Avatar;
